export default {
  props: ['value'],
  computed: {
    forwardModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
};
